/**
 * @flow
 * @relayHash 22e46c07e7bed424d7204bc68cbaf11c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailBackorderInput = {|
  backorderId: string
|};
export type EmailBackorderMutationVariables = {|
  input: EmailBackorderInput
|};
export type EmailBackorderMutationResponse = {|
  +emailBackorder: {|
    +success: boolean
  |}
|};
export type EmailBackorderMutation = {|
  variables: EmailBackorderMutationVariables,
  response: EmailBackorderMutationResponse,
|};
*/


/*
mutation EmailBackorderMutation(
  $input: EmailBackorderInput!
) {
  emailBackorder(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailBackorderInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailBackorder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailBackorderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailBackorderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailBackorderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailBackorderMutation",
    "id": null,
    "text": "mutation EmailBackorderMutation(\n  $input: EmailBackorderInput!\n) {\n  emailBackorder(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '29f85f8d16b804ab32af9fdb36a00428';
module.exports = node;
